import { ReactNode } from 'react';

import { Styles, css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

interface Props {
  children: ReactNode;
  css?: Styles;
}

export const GlassCard = ({ children, css: cssProps }: Props) => {
  return (
    <div
      className={css(
        stack.raw({
          rounded: 16,
          border: '1px solid rgba(255, 255, 255, 0.12)',
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0.02) 100%)',
          backdropFilter: 'blur(24px)',
          boxShadow: 'inset 0 1px 0 0 rgba(255, 255, 255, 0.08), 0 8px 32px 0 rgba(0, 0, 0, 0.30)',
        }),
        cssProps,
      )}
    >
      {children}
    </div>
  );
};
